export default function LogoComponent() {
  return <img src="../LogoMain.svg" alt="logo" width={"200px"} />;
}
